module.exports = __webpack_public_path__ + "static/media/my-app-vacation.2757565f.svg";